import { IAppState, IAction } from '../context/Context'
import { Framework } from '../../enums'
import { TCF } from '../../../../cmp/tcf/TCF'

export namespace Toggle {
  export const reducer = (
    prevState: IAppState,
    { settings }: IAction
  ): IAppState => {
    const updatedState = { ...prevState }
    if (settings && settings.framework === Framework.iab) {
      settings.status && TCF.tcModel[settings.property].set(settings.id)
      !settings.status && TCF.tcModel[settings.property].unset(settings.id)
    }
    if (settings && settings.framework === Framework.ac) {
      updatedState.acceptedAcPartners[settings.id] = settings.status
    }
    return updatedState
  }
}
